import APIconsume from 'Main/APIconsume'

const BASE_URL = '/api/dashboard/ip-whitelisting'

class IpWhitelistService {
  constructor () {
    this._apiConsume = new APIconsume()
  }

  /** GET /ip/ip-whitelisting */
  async getData () {
    const result = await this._apiConsume.getData(BASE_URL)
    return result?.data
  }

  /** GET /ip/ip-whitelisting/:id: used by the Edit flow (viewQrisConfig in the ejs). */
  async getById (id) {
    const result = await this._apiConsume.getData(`${BASE_URL}/${id}`)
    return result?.data
  }

  /** POST /ip/ip-whitelisting */
  async create (payload) {
    const result = await this._apiConsume.postData(payload, BASE_URL)
    return result?.data
  }

  /** PUT /ip/ip-whitelisting/:id */
  async update (id, payload) {
    const result = await this._apiConsume.putData(payload, `${BASE_URL}/${id}`)
    return result?.data
  }

  /** DELETE /ip/ip-whitelisting/:id */
  async deleteById (id) {
    const result = await this._apiConsume.deleteData(`${BASE_URL}/${id}`)
    return result?.data
  }

  /**
   * GET /vendors/payment-vendors: replaces the ejs's controller-injected
   * `paymentVendors` local.
   */
  async getPaymentVendors () {
    const result = await this._apiConsume.getData('/api/dashboard/payment-vendors')
    return result?.data
  }
}

export default IpWhitelistService
